import {
  ServiceVoucherStateTypes,
  ServiceVoucherActionTypes,
} from "./ServiceVoucher.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ServiceVoucherStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ServiceVoucherReducer = (
  state: ServiceVoucherStateTypes = INITIAL_STATE,
  action: any
): ServiceVoucherStateTypes => {
  switch (action.type) {
    case ServiceVoucherActionTypes.FETCH_ALL_SERVICE_VOUCHER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ServiceVoucherActionTypes.FETCH_ALL_SERVICE_VOUCHER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ServiceVoucherActionTypes.FETCH_ALL_SERVICE_VOUCHER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ServiceVoucherActionTypes.FETCH_ALL_SERVICE_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ServiceVoucherActionTypes.FETCH_ONE_SERVICE_VOUCHER:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ServiceVoucherActionTypes.FETCH_ONE_SERVICE_VOUCHER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ServiceVoucherActionTypes.FETCH_ONE_SERVICE_VOUCHER_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ServiceVoucherActionTypes.FETCH_ONE_SERVICE_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ServiceVoucherReducer;
